var exports = {
  "kL": "xfb577c5e--d923af--container",
  "Sl": "xfb577c5e--d923af--image",
  "DD": "xfb577c5e--d923af--title",
  "Qq": "xfb577c5e--d923af--text",
};

module.exports = exports;
